import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXTwitter } from "@fortawesome/free-brands-svg-icons";
import "./styles/Footer.css";

function Footer() {
  return (
    <footer className="goat-footer">
      {/* subtle top decoration */}
      <div className="goat-footer__topGlow" />

      <Container className="goat-footer__container">
        <Row className="g-4">
          {/* Brand / About */}
          <Col lg={4} md={12}>
            <div className="goat-footer__brandCard">
              <div className="goat-footer__logoRow">
                <div className="goat-footer__logo">𓄃</div>
                <div>
                  <h4 className="goat-footer__brandTitle">Goat Teachers</h4>
                  <p className="goat-footer__brandTag">Rate, Don't Hesitate!</p>
                </div>
              </div>

              <div className="goat-footer__social">
                <a
                  href="https://www.facebook.com/goatteachers"
                  className="goat-footer__socialBtn"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <FaFacebook />
                </a>
                <a
                  href="https://x.com/goatteachers"
                  className="goat-footer__socialBtn"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="X"
                >
                  <FontAwesomeIcon icon={faXTwitter} />
                </a>
                <a
                  href="https://www.instagram.com/goatteachers/"
                  className="goat-footer__socialBtn"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Instagram"
                >
                  <FaInstagram />
                </a>
                <a
                  href="https://www.linkedin.com/company/goatteachers/"
                  className="goat-footer__socialBtn"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="LinkedIn"
                >
                  <FaLinkedin />
                </a>
              </div>

              <div className="goat-footer__quick">
                <a
                  href="https://goatteachers.com/about"
                  className="goat-footer__pill"
                >
                  আমাদের সম্পর্কে
                </a>
                <a
                  href="https://goatteachers.com/siteguidelines"
                  className="goat-footer__pill"
                >
                  সাইট গাইডলাইনস
                </a>
              </div>
            </div>
          </Col>

          {/* Links */}
          <Col lg={4} md={6}>
            <div className="goat-footer__card">
              <h5 className="goat-footer__title">পলিসি</h5>
              <ul className="goat-footer__list">
                <li>
                  <a
                    href="https://goatteachers.com/siteguidelines"
                    className="goat-footer__link"
                  >
                    সাইট গাইডলাইনস
                  </a>
                </li>
                <li>
                  <a
                    href="https://goatteachers.com/terms"
                    className="goat-footer__link"
                  >
                    টার্মস &amp; কন্ডিশনস
                  </a>
                </li>
                <li>
                  <a
                    href="https://goatteachers.com/policy"
                    className="goat-footer__link"
                  >
                    প্রাইভেসী পলিসি
                  </a>
                </li>
                <li>
                  <a
                    href="https://goatteachers.com/copyright"
                    className="goat-footer__link"
                  >
                    কপিরাইট কমপ্লায়েন্স
                  </a>
                </li>
              </ul>
            </div>

            <div className="goat-footer__card goat-footer__card--mt">
              <h5 className="goat-footer__title">কমিউনিটি</h5>
              <ul className="goat-footer__list">
                <li>
                  <a
                    href="https://www.facebook.com/groups/tutornetw0rk"
                    target="_blank"
                    rel="noreferrer"
                    className="goat-footer__link"
                  >
                    Tutor Network
                  </a>
                </li>
              </ul>
            </div>
          </Col>

          {/* Contact Card */}
          <Col lg={4} md={6}>
            <div className="goat-footer__contactCard">
              <h5 className="goat-footer__title">যোগাযোগ</h5>

              <div className="goat-footer__contactRow">
                <span className="goat-footer__contactIcon">
                  <i className="fa-solid fa-envelope" aria-hidden="true"></i>
                  <span className="visually-hidden">Email</span>
                </span>

                <div>
                  <a
                    className="goat-footer__contactValue"
                    href="mailto:support@goatteachers.com"
                  >
                    support@goatteachers.com
                  </a>
                </div>
              </div>

              {/* <div className="goat-footer__contactRow">
                <span className="goat-footer__contactIcon">📞</span>
                <div>
                  <div className="goat-footer__contactLabel">হোয়াটস্যাপ</div>
                  <a
                    className="goat-footer__contactValue"
                    href="tel:+8801323719131"
                  >
                    +8801323719131
                  </a>
                </div>
              </div> */}

              <div className="goat-footer__cta">
                <div className="goat-footer__ctaText">
                  রিপোর্ট বা সহায়তার জন্য আমাদের সাথে যোগাযোগ করুন।
                </div>
                <a
                  className="goat-footer__ctaBtn"
                  href="https://wa.me/8801824796093?text=Hi%20Goat%20Teachers,%20I%20want%20to%20know%20more%20about%20this!"
                >
                  হোয়াটস্যাপ
                </a>
              </div>
            </div>
          </Col>
        </Row>

        <div className="goat-footer__bottom">
          <div className="goat-footer__bottomInner">
            <span> Made with ❤️ in Dhaka, Bangladesh.</span>
            <span className="goat-footer__dot" />
            <span>
              © 2024-2025 Goat Technologies Limited. All rights reserved.
            </span>
          </div>
        </div>
      </Container>
    </footer>
  );
}

export default Footer;
